import { render, staticRenderFns } from "./index1.vue?vue&type=template&id=161863b4&scoped=true"
import script from "./index1.vue?vue&type=script&lang=js"
export * from "./index1.vue?vue&type=script&lang=js"
import style0 from "./index1.vue?vue&type=style&index=0&id=161863b4&prod&lang=stylus&scoped=true"
import style1 from "./index1.vue?vue&type=style&index=1&id=161863b4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161863b4",
  null
  
)

export default component.exports